import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

const NotFound = () => (
  <div className="max-w-2xl mx-auto px-4 py-20 text-center">
    <div className="font-display text-7xl font-bold text-[#b91c1c]">404</div>
    <h1 className="font-display text-3xl font-bold text-[#0a0a0a] mt-2">Page Not Found</h1>
    <p className="text-gray-600 mt-2">The page you're looking for doesn't exist.</p>
    <Button asChild className="btn-red mt-6 h-12 px-8 font-bold uppercase tracking-wide"><Link to="/">Back to Home</Link></Button>
  </div>
);

export default NotFound;
